import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getDenyQuoteReason,
  getDenyQuoteShow,
  getDenyQuoteSure,
} from '../../../../../selectors/admin/work-orders/details/deny-quote';
import { Modal } from 'react-bootstrap';
import './DenyQuoteModal.css';
import RadioButton from '../../../../shared/radio-button/RadioButton';
import {
  changeReason,
  closeDenyQuoteModal,
  denyQuoteRequest,
  selectAnswer,
} from '../../../../../actions/admin/work-orders/details/deny-quote';
import TextArea from '../../../../shared/input/TextArea';
import {
  getCurrentTask,
  getQuotes,
} from '../../../../../selectors/admin/work-orders/details/details';

class DenyQuoteModal extends Component {
  handleQuestionAnswer = (value) => {
    this.props.dispatch(selectAnswer(value));
  };

  handleReasonChange = (value) => {
    this.props.dispatch(changeReason(value));
  };

  handleContinue = (event) => {
    event.preventDefault();

    if (this.props.sure) {
      const taskQuote = this.props.quotes.find(
        (quote) => quote.task.id === this.props.currentTask.id
      );
      if (taskQuote !== undefined) {
        this.props.dispatch(denyQuoteRequest(taskQuote.id, this.props.reason));
      }
    } else {
      this.props.dispatch(closeDenyQuoteModal());
    }
  };

  render() {
    return (
      <Modal className="deny-quote-modal" show={this.props.show}>
        <Modal.Body>
          <div className="h2">Are you sure?</div>
          <div>
            <RadioButton
              options={[
                {
                  value: 'yes',
                  label: 'Yes',
                },
                {
                  value: 'no',
                  label: 'No',
                },
              ]}
              value={
                this.props.sure === null ? null : this.props.sure ? 'yes' : 'no'
              }
              onChange={this.handleQuestionAnswer}
            />
          </div>

          {this.props.sure && (
            <div className="reason-container">
              <TextArea
                placeholder="Please enter a reason (optional)"
                value={this.props.reason}
                onChange={this.handleReasonChange}
              />
            </div>
          )}

          {this.props.sure !== null && (
            <div className="continue-container">
              <input
                className="btn button button-orange"
                value="Continue"
                type="button"
                onClick={this.handleContinue}
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    quotes: getQuotes(state),
    reason: getDenyQuoteReason(state),
    show: getDenyQuoteShow(state),
    sure: getDenyQuoteSure(state),
  };
})(DenyQuoteModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/quotes/DenyQuoteModal.js